import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { APIURL } from '../common/headers';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders } from '../common/headers';
import { IUsers } from '../database';
@Injectable()
export class StudentService {
    private _CountryUrl = '../data/countries.json';
    private _StateUrl = '../data/countries/';
    private _getStudentAllUrl = APIURL+'Student/getAllStudent';
    private _getStudentUrl = APIURL+'Student/getStudent';
    private _getStudentPayCatUrl = APIURL+'Student/getPayCat';
    private _getStudentScoreUrl = APIURL+'Student/getStudentScore';
     private currentUser :IUsers ; 
    constructor(private _http: Http) { 
           this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
   
    }
    getAllStudentpayCat(str_id){
        let formData:FormData = new FormData();
         formData.append('str_id', str_id);
        return this._http.post(this._getStudentPayCatUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    getStudentScore(str_id,examId){
        let formData:FormData = new FormData();
         formData.append('str_id', str_id);
         formData.append('examId', examId);
        return this._http.post(this._getStudentScoreUrl,formData )
                            .map((response: Response) => response.json())
    }                    
    getAllStudent(): any{
        return this._http.post(this._getStudentAllUrl,[] )
                            .map((response: Response) => response.json().data)
    }
    getStudent(userId): any  {
         let formData:FormData = new FormData();
         formData.append('userId', userId);
        return this._http.post(this._getStudentUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    getStudentById(con:string): any  {
        return this._http.post(this._StateUrl+con+".json",[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    add(con:string): any  {
        return this._http.post(this._StateUrl+con+".json",[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    edit(con:string): any  {
        return this._http.post(this._StateUrl+con+".json",[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    delete(con:string): any  {
        return this._http.post(this._StateUrl+con+".json",[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
     private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/student.service.ts